// extracted by mini-css-extract-plugin
export default {"tableContainer":"FormViewProposal_tableContainer__nvZi1"};